export default __webpack_public_path__ + "static/media/suitecase.61dea2fe.png";